import { ComputedRef, ToRefs, computed, toRefs } from 'vue';
import store from './store';

export function useMutations<
  T extends keyof typeof store._mutations,
  U extends RemoveNameSpace<T>,
  V extends GetNameSpace<T>,
  // @ts-expect-error
>(namespace: V): { [K in U]: (typeof store._mutations)[`${V}/${K}`] } {
  const mutationsMapper: Record<string, Function> = {};

  const mutationKeys = Object.keys(store._mutations).filter((mutation) => mutation.startsWith(`${namespace}/`));

  mutationKeys.forEach((mutationKey) => {
    const key = mutationKey.replace(`${namespace}/`, '');
    mutationsMapper[key] = function (...args: any[]) {
      return store.commit(mutationKey, ...args);
    };
  });

  // @ts-expect-error
  return mutationsMapper;
}

type RemoveSlash<T extends string> = T extends `${infer U}/` ? U : T;
export function useState<T extends keyof typeof store._modulesNamespaceMap, U extends RemoveSlash<T>>(
  namespace: U
): ToRefs<(typeof store._modulesNamespaceMap)[`${U}/`]['state']> {
  // const stateMapper: Record<string, any> = {};

  // const key = Object.keys(store._modulesNamespaceMap).find((key) => key === `${namespace}/`);

  // @ts-expect-error
  return toRefs(store._modulesNamespaceMap[`${namespace}/`].context.state);

  // stateKeys.forEach((stateKey) => {
  //   const key = stateKey.replace(`${namespace}/`, '');
  //   stateMapper[key] = computed(() => store.state[stateKey]);
  // });

  // return stateMapper;
}

type RemoveNameSpace<T extends string> = T extends `${infer U}/${infer V}` ? V : never;
type GetNameSpace<T extends string> = T extends `${infer U}/${infer V}` ? U : never;

type ToComputdRefs<T> = {
  [K in keyof T]: ComputedRef<T[K]>;
};

export function useGetters<
  T extends keyof typeof store.getters,
  U extends RemoveNameSpace<T>,
  V extends GetNameSpace<T>,
  // @ts-expect-error
>(namespace: V): ToComputdRefs<{ [K in U]: (typeof store.getters)[`${V}/${K}`] }> {
  const gettersMapper: Record<string, any> = {};

  const gettersKeys = Object.keys(store.getters).filter((getter) => getter.startsWith(`${namespace}/`));

  gettersKeys.forEach((getterKey) => {
    const key = getterKey.replace(`${namespace}/`, '');
    // @ts-expect-error
    gettersMapper[key] = computed(() => store.getters[getterKey]);
  });

  // @ts-expect-error
  return gettersMapper;
}

export function useActions<
  T extends keyof typeof store._actions,
  U extends RemoveNameSpace<T>,
  V extends GetNameSpace<T>,
  // @ts-expect-error
>(namespace: V): { [K in U]: (typeof store._actions)[`${V}/${K}`] } {
  const actionsMapper: Record<string, Function> = {};

  const actionsKeys = Object.keys(store._actions).filter((action) => action.startsWith(`${namespace}/`));

  actionsKeys.forEach((actionKey) => {
    const key = actionKey.replace(`${namespace}/`, '');
    actionsMapper[key] = function (...args: any[]) {
      return store.dispatch(actionKey, ...args);
    };
  });

  // @ts-expect-error
  return actionsMapper;
}
